import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-order-confirm-request-dialog',
  templateUrl: './work-order-confirm-request-dialog.component.html'
})
export class WorkOrderConfirmRequestDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
